<template>
  <card-component title="Para validar tu acceso, responde esta pregunta. En caso quieras recuperar tu contraseña más adelante, deberás recordar tu respuesta" icon="cellphone" :has-card-header-background="true" :has-button-slot="true">
    <b-loading :is-full-page="true" :active.sync="isLoading"/>
    <form @submit.prevent="submit" method="POST">
      <b-field label="2. ¿En qué ciudad naciste? (Ejemplo: Lima)"
      :type="showErrorField ? 'is-danger' : null">
        <div>
          <b-input v-model="phone" name="phone" validation-message="La respuesta solo debe contener letras"
                        pattern="^[A-Za-zÁÉÍÓÚÑáéíóúñ\s]+$" required autofocus @keypress.native="onlyLetters"/>
          <p
            v-if="showErrorField"
            class="help is-danger"
            v-html="errorMessage"
          ></p>
        </div>
      </b-field>
      <hr>
      <div class="control">
        <b-button  class="button is-orange" expanded @click="savePhoneNumber">
          Aceptar
        </b-button>
      </div>
    </form>
  </card-component>
</template>

<script>
import { mapState } from 'vuex'
import CardComponent from '@/components/CardComponent'
import TokenRepository from '@/services/TokenRepository'
import PhoneRepository from '@/services/PhoneRepository'
export default {
  name: 'AnswerSecurity',
  components: { CardComponent },
  data () {
    return {
      isLoadingStartClaim: false,
      isLoadingChangePassword: false,
      isLoading: false,
      showErrorField: false,
      phone: null,
      errorMessage: 'Esta respuesta no coincide con la que registraste inicialmente. Vuelve a ingresarla y en caso no se solucione, haz clic <a href=\'https://forms.office.com/r/YzsDyn6Ztc\' target="_blank"><b>AQUÍ</b></a> para poder ayudarte.'
    }
  },
  mounted () {
  },
  computed: {
    ...mapState([
      'idUser'
    ])
  },
  created () {
    if (this.idUser === null) {
      this.$router.push('/start-claim')
    }
  },
  methods: {
    normalizeAnswer (str) {
      if (!str) return ''
      return str.replace(/\s+/g, '').toUpperCase()
    },
    onlyLetters (event) {
      const char = String.fromCharCode(event.keyCode)
      const pattern = /^[A-Za-zÁÉÍÓÚÑáéíóúñ\s]$/
      if (!pattern.test(char)) {
        event.preventDefault()
      }
    },
    filterLetters (event) {
      // Permitimos letras, tildes, ñ, espacios
      let value = event.target.value
      value = value.replace(/[^A-Za-zÁÉÍÓÚÑáéíóúñ\s]/g, '') // elimina números y caracteres no permitidos
      this.phone = value
    },
    requestToken (data) {
      TokenRepository.requestTokenSMS(this.idUser, data)
        .then((r) => {
          this.$store.commit('removeIDUser')
          window.location.replace(r.data.url_to_claim)
        }).catch(e => {
          this.showError(e.response.data.detail)
        })
    },
    savePhoneNumber () {
      this.isLoading = true
      console.log(this.phone)
      const normalized = this.normalizeAnswer(this.phone)
      TokenRepository.getStatusUser(this.idUser
      ).then((r) => {
        console.log(r.data)
        if (r.data.claimed) {
          TokenRepository.getCheckSecurityStatus(
            this.idUser, normalized
          ).then((r) => {
            console.log('ingreso a if')
            console.log('ingreso a if' + r.data.state)
            if (r.data.state) {
              this.$router.push('/code-access')
            } else {
              this.showErrorField = true
              // this.$buefy.toast.open({
              //   message: 'Esta respuesta secreta no coincide con la que registraste inicialmente',
              //   type: 'is-danger'
              // })
              this.isLoading = false
            }
          })
        } else {
          console.log('ingreso a else')
          PhoneRepository.savePhoneNumber(
            this.idUser, { phone_number: normalized }
          ).then((r) => {
            TokenRepository.postChangeStatusUser(this.idUser)
            this.$router.push('/code-access')
          })
        }
      })
    //   PhoneRepository.savePhoneNumber(
    //     this.idUser, { phone_number: this.phone }
    //   ).then((r) => {
    //     // Here we re direct!
    //     console.log('entro')
    //     console.log(r.data)
    //     // this.requestToken(r.data)
    //   }).catch(e => {
    //     this.isLoading = false
    //     this.$buefy.toast.open({
    //       message: `Error: ${e.response.data.detail}`,
    //       type: 'is-danger'
    //     })
    //   })
    }
  }
}
</script>
<style>
.is-orange {
  background-color: #EF7D00 !important;
  color: #fff !important;
  border: none;
}
</style>
